module.exports = __webpack_public_path__ + "static/media/waterfowl@3x.58123188.jpg";